import { Button, Chip, Div, Text as Tx, } from "@bracket/ui";
import styled from "styled-components";
import { Icon } from "@components";

import { FieldDescription } from "./FieldDescription";



export const VerificationField: React.FC = () => {
  return (
    <>
			{/* description="Verify your account and unlock more features" */}
      <FieldDescription title="KYC" description="Coming Soon" />
      <UploadContainer>
				<Chip label="Not verified" icon="CrossCircle" />
        <Button label="Verify" variant="text" size="md" color="primary" />
				<Chip label="Verified" icon="ShieldCheck" />
        <Button label="Edit" variant="text" size="md" />
      </UploadContainer>
    </>
  );
};


const UploadContainer = styled(Div)`
  display: flex;
  gap: 16px;
  align-items: center;
`;
